import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { ErrorsInterface } from "../errors/errors-interface";
import setNewPasswordMutation from "./mutations/set-new-password";
import { Observable } from "rxjs";
import { FetchResult } from '@apollo/client/core';

interface PartnerUserResetPasswordResponse {
  partnerUser: {
    resetPassword: {
      output: { id: string };
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class SetNewPasswordService {
  constructor(private apollo: Apollo) {}

  setNewPassword(
    token: string,
    newPassword: string
  ): Observable<FetchResult<PartnerUserResetPasswordResponse>> {
    return this.apollo.mutate<PartnerUserResetPasswordResponse>({
      mutation: setNewPasswordMutation,
      variables: {
        token: token,
        newPassword: newPassword,
      },
    });
  }
}
